export default function (context, val) {
  context.state.list.find(i => {
    return i.code === val.agreement.code;
  }).CarryOverOfFunds = val.value;
}
